// Sticky cho .sukien-menu bằng JS.
// Lý do không dùng position:sticky thuần: libraryMainsite scale #MS__wrapper
// (transform) và tự quản scroll, nên scroll-container mà sticky bám vào không
// khớp phần thực sự cuộn -> menu không dính. Ở đây ta giữ menu trong luồng và
// dịch nó bằng translateY để nó "dán" mép trên khi cuộn, kẹp trong cột .inner.
window.addEventListener("load", function () {
  var menu = document.querySelector("#subpage-news-detail .sukien-menu");
  if (!menu) return;
  var column = menu.parentElement; // .inner (cột chứa menu + bài viết)
  var wrapper = document.getElementById("MS__wrapper");
  var OFFSET_DESIGN = 30; // px (design) cách mép trên khi dính

  var ticking = false;

  // Tỉ lệ scale lib áp lên #MS__wrapper = rộng thực tế / rộng layout (2000px).
  // translateY set trong hệ toạ độ design nên phải chia screen-px cho scale.
  function getScale() {
    if (!wrapper || !wrapper.offsetWidth) return 1;
    return wrapper.getBoundingClientRect().width / wrapper.offsetWidth || 1;
  }

  function update() {
    ticking = false;
    // Menu ẩn (mobile) -> bỏ transform, thôi
    if (menu.offsetParent === null) {
      menu.style.transform = "";
      return;
    }
    var k = getScale();
    // Đo ở trạng thái translate = 0 để lấy vị trí tự nhiên trong luồng
    menu.style.transform = "";
    var mRect = menu.getBoundingClientRect();
    var cRect = column.getBoundingClientRect();

    var desired = OFFSET_DESIGN * k; // vị trí muốn dán (screen px)
    var translateScreen = desired - mRect.top; // lượng đẩy xuống (screen px)
    if (translateScreen < 0) translateScreen = 0;

    // Không cho menu vượt quá đáy cột .inner
    var maxTranslate = cRect.bottom - mRect.top - mRect.height;
    if (maxTranslate < 0) maxTranslate = 0;
    if (translateScreen > maxTranslate) translateScreen = maxTranslate;

    menu.style.transform = "translateY(" + translateScreen / k + "px)";
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  // capture:true để bắt cả scroll xảy ra bên trong #MS__wrapper (scroll không bubble)
  document.addEventListener("scroll", onScroll, true);
  window.addEventListener("resize", onScroll);
  update();
});
